<template>
    <div class="url">
        <div class="url-page">
            <VHeader page="UrlPage"></VHeader>
            <div class="url-page-wrapper">
                <div class="url-page-wrapper_title url-page-wrapper_text">
                    Domain
                </div>
                <VSelect
                    v-model="newUrl.domainObj"
                    :class="{'url-page-wrapper_error' : isDomainEmpty}"
                    :options="domains"
                    :show-property="'domain'"
                >
                    <VButton>{{ newUrl.domainObj.domain || 'choose domain' }}</VButton>
                </VSelect>
            </div>
            <div class="url-page-wrapper">
                <div class="url-page-wrapper_title url-page-wrapper_text">
                    Path*
                </div>
                <VInput
                    :class="{'url-page-wrapper_error' : isPathEmpty}"
                    v-model="newUrl.path"
                    placeholder='Path*'
                ></VInput>
            </div>
            <div class="url-page-wrapper">
                <div class="url-page-wrapper_title url-page-wrapper_text">
                    Application
                </div>
                <VSelect
                    v-model="newUrl.project"
                    :class="{'url-page-wrapper_error' : isApplicationEmpty}"
                    :options="projects"
                    :show-property="'title'"
                    :icon-property="'logo_small'"
                >
                    <VButton
                    >
                        <img
                            v-if="newUrl.project.title"
                            :src="newUrl.project.logo_small"
                            alt="Painting"
                        >
                        {{ newUrl.project.title || 'choose application' }}
                    </VButton>
                </VSelect>
            </div>
            
            <div class="url-page-wrapper">
                <div class="url-page-wrapper_title url-page-wrapper_text">
                    Target*
                </div>
                <VInput
                    :class="{'url-page-wrapper_error' : isTargetEmpty}"
                    :disabled="Object.keys(newUrl.project).length === 0"
                    v-model="newUrl.target"
                    placeholder='Target*'
                ></VInput>
            </div>
            <div class="url-page-wrapper">
                <div class="url-page-wrapper_title ">
                    Description
                </div>
                <VInput
                    v-model="newUrl.description"
                    placeholder='Description'
                ></VInput>
            </div>
            <div class="url-page-wrapper url-page-wrapper__button">
                <VButton
                    @click="addUrl"
                    :type="'button'"
                    theme="positive"
                >Add link
                </VButton>
            </div>
            <div class="url-page-table highlighted-table">
                <template>
                    <div class="url-page-table-header">
                        <div
                            class="url-page-table-header-title"
                            v-for="(columnTitle, columnName) in table"
                            :key="columnName"
                            @click="sorting(columnName)"
                        >
                             <span
                                 v-if="filterValue.name === columnName"
                                 class="filter-icon"
                             >
                                <span
                                    :class="{'filter-triangle-icon_descending': filterValue.direction==='descending'}"
                                    class="filter-triangle-icon"
                                >
                                </span>
                            </span>
                            {{ columnTitle }}
                        </div>
                    
                    </div>
                    <div
                        class="url-page-table-row "
                        v-for="(urlPage, urlPageIndex) in urls"
                        :key="urlPage.name"
                    >
                        <div
                            class="url-page-table-row-text url-page-table-row-text_link"
                            @click="copyToClipboard(urlPage.link)"
                        >
                            {{ urlPage.link }}
                        </div>
                        <div class="url-page-table-row-text ">
                            {{ urlPage.domain }}
                        </div>
                        <div class="url-page-table-row-text ">
                            <img
                                v-if="urlPage.bundle_id && getBundleIdImageUrl(urlPage.bundle_id)"
                                :src="getBundleIdImageUrl(urlPage.bundle_id)"
                                alt="Painting"
                            >
                            {{ urlPage.bundle_id }}
                        </div>
                        <div class="url-page-table-row-text">
                            {{ urlPage.path }}
                        </div>
                        <div
                            class="url-page-table-row-text url-page-table-row-text_link"
                        >
                            <a
                                :href="urlPage.target"
                                target="_blank"
                            >{{ urlPage.target }}</a>
                        </div>
                        <div class="url-page-table-row-text">
                            {{ urlPage.description }}
                        </div>
                        <div class="url-page-table-row-close-position">
                            <div
                                class="url-page-table-row-close-position-icon"
                                @click="deleteUrlPage(urlPageIndex)"
                            >
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import VInput from '../components/VInput';
    import VSelect from '../components/VSelect';
    import {getProjects} from '../api/apiServices';
    import apiUrls from '../api/apiUrls';
    
    export default {
        name: 'Urls',
        components: {
            VInput,
            VSelect,
        },
        data() {
            return {
                isDomainEmpty: false,
                isApplicationEmpty: false,
                isPathEmpty: false,
                isTargetEmpty: false,
                projects: getProjects(),
                domains: [],
                newUrl: {},
                emptyUrl: Object.freeze({
                    domainObj: {},
                    project: {},
                    path: '',
                    target: '',
                    description: '',
                }),
                urls: [],
                filterValue: {
                    name: null,
                    direction: null,
                },
                table: {
                    link: 'Url (click to copy)',
                    domain: 'Domain',
                    bundle_id: 'Bundle_id',
                    path: 'Path',
                    target: 'Target',
                    description: 'description',
                    '': '',
                },
            };
        },
        watch: {
            'newUrl.project': {
                handler() {
                    if (this.newUrl.project) {
                        this.generateTargetString();
                    }
                },
            },
        },
        created() {
            this.init();
            
            apiUrls.getDomains().then((response) => {
                this.domains = response.data;
            }).catch((error) => {
                if (error.response) {
                    this.$toastr.longError(
                        `Api request error : ${error.response.data.error}`,
                    );
                }
            });
            
            apiUrls.getUrls().then((response) => {
                this.urls = response.data.map((url) => {
                    url.link = this.generateFullLink(url.domain, url.path);
                    return url;
                });
            }).catch((error) => {
                if (error.response) {
                    this.$toastr.longError(
                        `Api request error : ${error.response.data.error}`,
                    );
                }
            });
        },
        methods: {
            copyToClipboard(text) {
                const elem = document.createElement('textarea');
                elem.value = text;
                document.body.appendChild(elem);
                elem.select();
                document.execCommand('copy');
                document.body.removeChild(elem);
                this.$toastr.s(
                    'Text copied',
                );
            },
            init() {
                this.newUrl = _.cloneDeep(this.emptyUrl);
                this.newUrl.path = `/${this.generatePathString(10)}`;
            },
            generateFullLink(domain, path) {
                return `https://${domain}${path}`;
            },
            generatePathString(length) {
                let result = '';
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() *
                        characters.length));
                }
                return result;
            },
            generateTargetString() {
                const application = getProjects().find((app) => app.bundle_id === this.newUrl.project.bundle_id);
                if (application) {
                    const store_id = application.id;
                    this.newUrl.target = `https://app.appsflyer.com/${store_id}`;
                }
            },
            addUrl() {
                this.isDomainEmpty = false;
                this.isApplicationEmpty = false;
                this.isPathEmpty = false;
                this.isTargetEmpty = false;
                
                if (!this.newUrl.domainObj.domain) {
                    this.$toastr.longError('Domain can\'t be empty');
                    this.isDomainEmpty = true;
                }
                if (!this.newUrl.project.title) {
                    this.$toastr.longError('Application can\'t be empty');
                    this.isApplicationEmpty = true;
                }
                if (!this.newUrl.path) {
                    this.$toastr.longError('path can\'t be empty');
                    this.isPathEmpty = true;
                }
                if (!this.newUrl.target) {
                    this.$toastr.longError('path can\'t be empty');
                    this.isTargetEmpty = true;
                }
                if (this.newUrl.path && this.newUrl.target && this.newUrl.domainObj.domain && this.newUrl.project.title) {
                    const sendUrlPage = _.cloneDeep(this.newUrl);
                    const tableUrl = _.cloneDeep(this.newUrl);
                    sendUrlPage.domain_id = this.newUrl.domainObj.id;
                    sendUrlPage.bundle_id = this.newUrl.project.bundle_id;
                    delete sendUrlPage.domain;
                    delete sendUrlPage.project;
                    
                    tableUrl.bundle_id = tableUrl.project.bundle_id;
                    tableUrl.domain = tableUrl.domainObj.domain;
                    delete tableUrl.project;
                    
                    apiUrls.addClicks(sendUrlPage).then((response) => {
                        tableUrl.id = response.data.id;
                        tableUrl.link = this.generateFullLink(this.newUrl.domainObj.domain, this.newUrl.path);
                        this.urls.push(tableUrl);
                        this.$toastr.s(
                            'Url added',
                        );
                        this.init();
                    }).catch((error) => {
                        if (error.response) {
                            this.$toastr.longError(
                                `Api request error : ${error.response.data.error}`,
                            );
                        }
                    });
                    
                }
            },
            deleteUrlPage(urlPageIndex) {
                apiUrls.deleteUrlPages(this.urls[urlPageIndex].id).then(() => {
                    this.$toastr.s('Deleted');
                    this.urls.splice(urlPageIndex, 1);
                }).catch((error) => {
                    if (error.response) {
                        this.$toastr.longError(
                            `Api request error : ${error.response.data.error}`,
                        );
                    }
                });
            },
            sorting(property, isChangeDirection = true) {
                if (isChangeDirection && this.filterValue.name === property) {
                    this.filterValue.direction = this.filterValue.direction === 'descending' ? 'ascending' : 'descending';
                } else if (isChangeDirection) {
                    this.filterValue.direction = 'ascending';
                }
                if (this.filterValue.direction) {
                    this.filterValue.name = property;
                    
                    this.urls = this.urls.sort((a, b) => {
                        if (a[property] < b[property]) {
                            return this.filterValue.direction === 'ascending' ? -1 : 1;
                        }
                        if (a[property] > b[property]) {
                            return this.filterValue.direction === 'ascending' ? 1 : -1;
                        }
                        return 0;
                    });
                }
                
            },
            getBundleIdImageUrl(bundleId) {
                const project = getProjects().find((project) => project.bundle_id === bundleId);
                if (project) {
                    return project.logo_small;
                }
                return '';
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    
    .url {
        color: $dark-blue-color;
        
        &-page {
            
            &-wrapper {
                display: flex;
                width: 228px;
                margin-left: 10px;
                margin-top: 5px;
                
                ::v-deep {
                    .VButton {
                        width: 296px;
                        
                        .VButton__title {
                            display: flex;
                            align-items: center;
                            margin-right: 20px;
                            
                            img {
                                width: 14px;
                                height: 14px;
                                margin-right: 20px;
                            }
                        }
                    }
                }
                
                ::v-deep {
                    
                    .VSelect-dropdown__li {
                        display: flex;
                        align-items: center;
                        
                        img {
                            width: 25px;
                            height: 25px;
                            margin-right: 20px;
                        }
                    }
                    
                }
                
                &_title {
                    display: flex;
                    min-width: 100px;
                    align-items: center;
                    padding-top: 5px;
                }
                
                &_text {
                    color: red;
                }
                
            }
            
            .url-page-wrapper_error {
                ::v-deep {
                    input {
                        border-color: red;
                    }
                }
                
                ::v-deep {
                    .VButton {
                        border-color: red;
                    }
                }
            }
            
            ::v-deep {
                input {
                    width: 300px;
                }
            }
            
            &-wrapper_traffic {
                margin-right: -264px;
                align-self: center;
                
            }
            
            &-wrapper_traffic__description {
                margin-left: 15px;
            }
            
            &-wrapper__button {
                display: flex;
                margin-top: 15px;
                margin-left: 208px;
                
                ::v-deep {
                    .VButton {
                        width: 68px;
                        
                        &__title {
                            margin-right: 4px;
                        }
                    }
                }
            }
            
            &-table {
                border-radius: 10px;
                @include dark-shadow;
                max-width: 100%;
                margin: 26px;
                
                &-header {
                    display: flex;
                    height: 53px;
                    border-bottom: 1px solid #6089E7;
                    
                    &-title {
                        display: flex;
                        justify-content: center;
                        padding: 17px;
                        margin-top: 13px;
                        font-family: Poppins;
                        height: 12px;
                        color: #000F48;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 12px;
                        width: 15%;
                        cursor: pointer;
                        
                        &:last-child {
                            width: 47px;
                            padding: 0;
                        
                        }
                    }
                    
                }
                
                &-row {
                    display: flex;
                    min-height: 45px;
                    border-top: 1px solid rgba(96, 137, 231, 0.2);
                    
                    &-text {
                        display: flex;
                        justify-content: center;
                        font-family: Quicksand;
                        word-break: break-word;
                        padding: 17px;
                        color: #000F48;
                        font-size: 14px;
                        letter-spacing: 0;
                        width: 15%;
                        text-align: center;
                        align-items: center;
                        gap: 10px;
                        
                        img {
                            width: 30px;
                        }
                        
                        @media (max-width: 927px) {
                            font-size: 12px;
                        }
                    }
                    
                    &-text_link {
                        cursor: pointer;
                        color: #00cd96;
                    }
                    
                    &-text_link:hover {
                        color: #800000;
                        text-decoration: underline;
                    }
                    
                    &-close-position {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 47px;
                        
                        &-icon {
                            padding: 10px;
                            width: 10px;
                            background-repeat: no-repeat;
                            background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE3cHgiIGhlaWdodD0iMTdweCIgdmlld0JveD0iMCAwIDE3IDE3IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPg0KICAgIDx0aXRsZT41QzJERjVGNi01QzAwLTRFQjctQTBBMS0wQUJEMDc4NDdERTFAMSw1eDwvdGl0bGU+DQogICAgPGcgaWQ9IlBhZ2UtNCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzLjAwMDAwMCwgLTQ0NC4wMDAwMDApIiBmaWxsPSIjMDJERkIwIiBzdHJva2U9IiM2MDg5RTciPg0KICAgICAgICAgICAgPGcgaWQ9Imljb24vY2xvc2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjAwMDAwMCwgNDQ1LjAwMDAwMCkiPg0KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjcwNzEwNjc4LDAuMjkyODkzMjE5IEw3LjQ1OSw2LjA0NSBMMTMuMTA1ODgwOCwwLjM5OTIyNTA2NiBDMTMuNTAyMjc3NiwwLjAwMjgyODIyODEyIDE0LjE0NDk2MzksMC4wMDI4MjgyMjgxMiAxNC41NDEzNjA3LDAuMzk5MjI1MDY2IEMxNC45Mzc3NTc1LDAuNzk1NjIxOTAzIDE0LjkzNzc1NzUsMS40MzgzMDgxNiAxNC41NDEzNjA3LDEuODM0NzA1IEw4Ljg5NSw3LjQ4IEwxNC42NDc2OTI1LDEzLjIzMzQ3OSBDMTUuMDM4MjE2OCwxMy42MjQwMDMzIDE1LjAzODIxNjgsMTQuMjU3MTY4MiAxNC42NDc2OTI1LDE0LjY0NzY5MjUgQzE0LjI1NzE2ODIsMTUuMDM4MjE2OCAxMy42MjQwMDMzLDE1LjAzODIxNjggMTMuMjMzNDc5LDE0LjY0NzY5MjUgTDcuNDgsOC44OTUgTDEuODM0NzA1LDE0LjU0MTM2MDcgQzEuNDM4MzA4MTYsMTQuOTM3NzU3NSAwLjc5NTYyMTkwMywxNC45Mzc3NTc1IDAuMzk5MjI1MDY2LDE0LjU0MTM2MDcgQzAuMDAyODI4MjI4MTIsMTQuMTQ0OTYzOSAwLjAwMjgyODIyODEyLDEzLjUwMjI3NzYgMC4zOTkyMjUwNjYsMTMuMTA1ODgwOCBMNi4wNDUsNy40NTkgTDAuMjkyODkzMjE5LDEuNzA3MTA2NzggQy0wLjA5NzYzMTA3MjksMS4zMTY1ODI0OSAtMC4wOTc2MzEwNzI5LDAuNjgzNDE3NTExIDAuMjkyODkzMjE5LDAuMjkyODkzMjE5IEMwLjY4MzQxNzUxMSwtMC4wOTc2MzEwNzI5IDEuMzE2NTgyNDksLTAuMDk3NjMxMDcyOSAxLjcwNzEwNjc4LDAuMjkyODkzMjE5IFoiPjwvcGF0aD4NCiAgICAgICAgICAgIDwvZz4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg==');
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        
        .filter-icon {
            position: relative;
            height: 5px;
            width: 3px;
            display: inline-block;
        }
        
        .filter-triangle-icon {
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 2.5px 5px 2.5px;
            border-color: transparent transparent #00cd96 transparent;
            position: absolute;
            right: 2px;
            top: 5px;
            
            &_descending {
                transform: rotate(180deg);
            }
        }
    }
</style>